// src/padplanner/planFilters.js
//
// The plan list's filters, shared by the dashboard's All plans card and the
// plans list panel: a tab, a type, an owner, a landowner (158) and a search
// become the query GET /plans takes. Moved out of PlansListPage.jsx so that file exports only
// its component.
//
// The project is NOT here. The TopNav picker sends it as x-aiprime-project on
// every call (fetchWithAuth), and the server filters by it (148); a page only
// has to ask again when the picker changes.

/**
 * {tab: 'all'|status|'archived', planType, owner: ''|'me', landowner: ''|'any'|'none'|org id, q}
 * -> listPlans filters
 */
export function filtersFor({ tab, planType, owner, landowner, q }) {
  const f = {};
  if (tab === "archived") f.archived = "only";
  else if (tab && tab !== "all") f.status = tab;
  if (planType) f.plan_type = planType;
  if (owner) f.owner = owner;
  if (landowner) f.landowner = landowner;
  if (q && q.trim()) f.q = q.trim();
  return f;
}

/** How many plans a tab holds, from the dashboard answer's counts; null before it loads. */
export function countForTab(counts, tab) {
  if (!counts) return null;
  if (tab === "all") return counts.active;
  if (tab === "archived") return counts.archived;
  return counts.by_status?.[tab] ?? null;
}
